<template>
  <div>
    <a-row :gutter="16" class="margin-bottom-20">
      <a-col :span="4">
        <div class="statistic" @click="_getOverdueThirty">
          <div class="text-line">
            <div class="title max-height">逾期客户</div>
            <div class="num">{{ remindData.overdueThirtyCount }}</div>
          </div>
          <div style="background: rgb(237, 79, 56, .1)" class="icon-div">
            <a-icon type="clock-circle" class="icon" style="color: #ED4F38;" />
          </div>
        </div>
      </a-col>
      <a-col :span="4">
        <div class="statistic" @click="_getExpirationLimit">
          <div class="text-line">
            <div class="title max-height">近30天到期限额和额度</div>
            <div class="num">{{ remindData.expirationAmountCount }}</div>
          </div>
          <div style="background: rgb(253, 178, 90, .1)" class="icon-div">
            <a-icon type="money-collect" class="icon" style="color: #FDB25A;" />
          </div>
        </div>
      </a-col>
      <a-col :span="4">
        <div class="statistic" @click="_getExpirationLoan">
          <div class="text-line">
            <div class="title max-height">近30天到期担保和保险</div>
            <div class="num">{{ remindData.expirationInsuranceCount }}</div>
          </div>
          <div style="background: rgb(1, 81, 255, .1)" class="icon-div">
            <a-icon type="dollar" class="icon" style="color: #0151FF;" />
          </div>
        </div>
      </a-col>
      <a-col :span="4">
        <div class="statistic" @click="_getRiskData">
          <div class="text-line">
            <div class="title max-height">限额超担保或保险</div>
            <div class="num">{{ remindData.limitOverInsuranceCount }}</div>
          </div>
          <div style="background: rgb(1, 81, 255, .1)" class="icon-div">
            <a-icon type="sound" class="icon" style="color: #8b6ef3;" />
          </div>
        </div>
      </a-col>
      <a-col :span="4">
        <div class="statistic" @click="_getLoanData">
          <div class="text-line">
            <div class="title max-height">额度超限额</div>
            <div class="num">{{ remindData.riskCount }}</div>
          </div>
          <div style="background: rgb(1, 81, 255, .1)" class="icon-div">
            <a-icon type="radar-chart" class="icon" style="color: #8b6ef3;" />
          </div>
        </div>
      </a-col>
    </a-row>

    <div class="line-wrapper">
      <a-row :gutter="16" class="margin-bottom-20">
        <a-col :span="16">
          <h3>我的审批</h3>
          <ApproveTabs />
        </a-col>
        <a-col :span="8">
          <h3>工作委托</h3>
          <DelegateTabs />
        </a-col>
      </a-row>
    </div>

    <ChartTabs />

    <!--逾期客户-->
    <a-modal
      title="记录"
      :width="950"
      :visible="overdueThirtyVisible"
      :footer="null"
      :maskClosable="false"
      @cancel="overdueThirtyVisible = false"
    >
      <TableView
        :data="overdueThirtyData"
        :columns="overdueThirtyColumns"
        :pagination="overdueThirtyPageData"
        :scroll="{ x: 800 }"
        rowKey="index"
        :loading="overdueThirtyTableLoading"
        @handlePagination="handleOverdueThirtyClickPage"
      >
        <template v-slot:name="{ tableRow }">
          <span class="name" @click="goApplicationData(tableRow)">
            {{ tableRow.name }}
          </span>
        </template>
      </TableView>
    </a-modal>
    <!--近30天到期限额和额度弹窗-->
    <a-modal
      title="记录"
      :width="950"
      :visible="expirationLimitVisible"
      :footer="null"
      :maskClosable="false"
      @cancel="expirationLimitVisible = false"
    >
      <TableView
        :data="expirationLimitData"
        :columns="expirationLimitColumns"
        :pagination="expirationLimitPageData"
        rowKey="index"
        :scroll="{ x: 800 }"
        :loading="expirationLimitTableLoading"
        @handlePagination="handleExpirationLimitClickPage"
      >
        <template v-slot:name="{ tableRow }">
          <span class="name" @click="goCredits(tableRow)">
            {{ tableRow.name }}
          </span>
        </template>
      </TableView>
    </a-modal>
    <!--近30天到期担保和保险弹窗-->
    <a-modal
      title="记录"
      :width="950"
      :visible="expirationLoanVisible"
      :footer="null"
      :maskClosable="false"
      @cancel="expirationLoanVisible = false"
    >
      <!--近30天到期担保 担保 -->
      <TableView
        rowKey="index"
        :data="expirationLoanData"
        tableCardTitle="近30天到期担保"
        :columns="expirationLoanColumns"
        :pagination="expirationLoanPageData"
        :scroll="{ x: 800 }"
        :loading="expirationLoanTableLoading"
        @handlePagination="handleExpirationLoanClickPage"
      >
        <template v-slot:companyName="{ tableRow }">
          <span class="name" @click="goGuarantee(tableRow)">
            {{ tableRow.companyName }}
          </span>
        </template>
      </TableView>
      <!-- 保险 -->
      <TableView
        rowKey="index"
        :data="insureanceLoanData"
        tableCardTitle="近30天到期保险"
        :columns="insureanceLoanColumns"
        :pagination="insureanceLoanPageData"
        :scroll="{ x: 800 }"
        :loading="insureanceLoanTableLoading"
        @handlePagination="handleInsureanceLoanClickPage"
      >
        <template v-slot:companyName="{ tableRow }">
          <span class="name" @click="goInsurance(tableRow)">
            {{ tableRow.companyName }}
          </span>
        </template>
      </TableView>
    </a-modal>
    <!--限额超担保或保险-->
    <a-modal
      title="记录"
      :width="950"
      :visible="riskVisible"
      :footer="null"
      :maskClosable="false"
      @cancel="riskVisible = false"
    >
      <!-- 担保 -->
      <TableView
        :data="riskData"
        :columns="riskColumns"
        tableCardTitle="限额超担保"
        :pagination="riskPageData"
        rowKey="index"
        :scroll="{ x: 800 }"
        :loading="riskTableLoading"
        @handlePagination="handleRiskClickPage"
      >
        <template v-slot:companyName="{ tableRow }">
          <span class="name" @click="goRiskCredits(tableRow)">
            {{ tableRow.companyName }}
          </span>
        </template>
      </TableView>
      <!-- 保险 -->
      <TableView
        :data="riskINSUData"
        :columns="riskINSUColumns"
        :pagination="riskINSUPageData"
        tableCardTitle="限额超保险"
        rowKey="index"
        :scroll="{ x: 800 }"
        :loading="riskINSUTableLoading"
        @handlePagination="handleRiskINSUClickPage"
      >
        <template v-slot:companyName="{ tableRow }">
          <span class="name" @click="goRiskCredits(tableRow)">
            {{ tableRow.companyName }}
          </span>
        </template>
      </TableView>
    </a-modal>
    <!-- 额度超限额提示 -->
    <a-modal
      title="记录"
      :width="950"
      :visible="loanVisible"
      :footer="null"
      :maskClosable="false"
      @cancel="loanVisible = false"
    >
      <TableView
        :data="loanData"
        :columns="loanColumns"
        :pagination="loanPageData"
        rowKey="index"
        :scroll="{ x: 800 }"
        :loading="loanTableLoading"
        @handlePagination="handleLoanClickPage"
      >
        <template v-slot:name="{ tableRow }">
          <span class="name" @click="goCredits(tableRow)">
            {{ tableRow.name }}
          </span>
        </template>
      </TableView>
    </a-modal>
  </div>
</template>

<script>
import {
  getRemindData,
  getOverdueThirty,
  getExpirationLimit,
  getExpirationLoan,
  getInsureanceLoan,
  getOverdueForth,
  getINSUData,
  getASURData,
} from './api'

import { TableView } from 'lxfintech-fe'
import mixin from './mixin'
import ChartTabs from './components/ChartTabs'
import ApproveTabs from './components/ApproveTabs'
import DelegateTabs from './components/DelegateTabs'
import { mapMutations } from 'vuex'
import { SET_COMPANY } from 'config/mutation-types/app'
import moment from 'moment'

const STATUS_TYPE = {
  1: {
    color: 'green',
    text: '生效',
  },
  2: {
    color: 'red',
    text: '失效',
  },
  3: {
    color: 'orange',
    text: '取消',
  },
}

export default {
  mixins: [mixin],
  data() {
    return {
      loading: true,
      workRecordingList: [],
      confirmLoading: false,
      overdueThirtyVisible: false,
      expirationLimitVisible: false,
      expirationLoanVisible: false,
      riskVisible: false,
      loanVisible: false,
      STATUS_TYPE,
      remindData: {},
    }
  },
  mounted() {
    this._getRemindData()
  },
  components: { TableView, ChartTabs, ApproveTabs, DelegateTabs },
  methods: {
    ...mapMutations('app', [SET_COMPANY]),
    // setHeight() {
    //   const cardGrid = document.getElementsByClassName('card-grid')
    //   for (let i = 0; i < cardGrid.length; i++) {
    //     cardGrid[i].style.height = this.cardHeight + 'px'
    //   }
    // },
    goApplicationData(data) {
      const { id, code, name } = data
      this.SET_COMPANY({ name, code })
      this.$router.push(`/client/client-center/detail/application-data/${id}`)
    },
    goCredits(data) {
      const { id, code, name } = data
      this.SET_COMPANY({ name, code })
      this.$router.push(`/client/client-center/detail/credits/${id}`)
    },
    goRiskCredits(data) {
      const { id, companyCode, companyName } = data
      this.SET_COMPANY({ companyName, companyCode })
      this.$router.push(`/client/client-center/detail/credits/${id}`)
    },
    goGuarantee(data) {
      const { id, companyCode, companyName } = data
      this.SET_COMPANY({ companyName, companyCode })
      this.$router.push(`/client/client-center/detail/guarantee/${id}`)
    },
    goInsurance(data) {
      const { id, companyCode, companyName } = data
      this.SET_COMPANY({ companyName, companyCode })
      this.$router.push(`/client/client-center/detail/insurance/${id}`)
    },
    _getOverdueThirty() {
      this.overdueThirtyTableLoading = true
      const { pageSize: size, current } = this.overdueThirtyPageData
      getOverdueForth({ size, current }).then(({ data }) => {
        const { records, total } = data
        this.overdueThirtyData = records
        this.overdueThirtyTableLoading = false
        this.overdueThirtyPageData.total = total
        this.overdueThirtyVisible = true
      })
    },
    _getExpirationLimit() {
      this.expirationLimitTableLoading = true
      const { pageSize: size, current } = this.expirationLimitPageData
      getExpirationLimit({ size, current }).then(({ data }) => {
        const { records, total } = data
        this.expirationLimitData = records
        this.expirationLimitTableLoading = false
        this.expirationLimitPageData.total = total
        this.expirationLimitVisible = true
      })
    },
    // 担保
    _getAssuranceLoan() {
      this.expirationLoanTableLoading = true

      const { pageSize: size, current } = this.expirationLoanPageData
      getExpirationLoan({ size, current }).then(({ data }) => {
        const { records, total } = data
        this.expirationLoanData = records
        this.expirationLoanData.map(item => {
          item.expireDate = moment(item.expireDate).format('YYYY-MM-DD')
        })
        this.expirationLoanTableLoading = false
        this.expirationLoanPageData.total = total
        this.expirationLoanVisible = true
      })
    },
    _getExpirationLoan() {
      this._getAssuranceLoan()
      this._getInsureanceLoan()
    },
    // 保险
    _getInsureanceLoan() {
      this.insureanceLoanTableLoading = true

      const { pageSize: size, current } = this.insureanceLoanPageData
      getInsureanceLoan({ size, current }).then(({ data }) => {
        const { records, total } = data
        this.insureanceLoanData = records
        this.insureanceLoanData.map(item => {
          item.expireDate = moment(item.expireDate).format('YYYY-MM-DD')
        })
        this.insureanceLoanTableLoading = false
        this.insureanceLoanData.total = total
        this.expirationLoanVisible = true
      })
    },
    _getRemindData() {
      getRemindData().then(({ data }) => {
        this.remindData = data
      })
    },

    _getLoanData() {
      this.loanTableLoading = true

      const { pageSize: size, current } = this.loanPageData
      getOverdueThirty({ size, current }).then(({ data }) => {
        const { records, total } = data
        this.loanData = records
        this.loanTableLoading = false
        this.loanPageData.total = total
        this.loanVisible = true
      })
    },
    // 担保
    getLoanAssurance() {
      this.riskTableLoading = true
      const { pageSize: size, current } = this.riskPageData
      getASURData({ size, current }).then(({ data }) => {
        const { records, total } = data
        this.riskData = records
        this.riskTableLoading = false
        this.riskPageData.total = total
        this.riskVisible = true
      })
    },
    // 保险的限额
    getLoanInsurance() {
      this.riskINSUTableLoading = true
      const { pageSize: size, current } = this.riskINSUPageData
      getINSUData({ size, current }).then(({ data }) => {
        const { records, total } = data
        this.riskINSUData = records
        this.riskINSUTableLoading = false
        this.riskINSUPageData.total = total
        this.riskVisible = true
      })
    },
    _getRiskData() {
      this.getLoanInsurance()
      this.getLoanAssurance()
    },
  },
}
</script>

<style lang="less" scoped>
@media screen and (max-width: 1450px) {
  .max-height {
    height: 48px;
  }
}

.statistic {
  background: #fff;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  .text-line {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .icon-div {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon {
    font-size: 30px;
  }
  .title {
    font-size: 16px;
  }
  .num {
    font-size: 26px;
  }
}
/deep/.ant-col-4 {
  width: 20%;
}
/deep/ .ant-card-body {
  padding: 0;
}
.card-grid {
  width: 100%;
  height: 300px;
  img {
    margin-right: 10px;
  }
  p {
    display: inline-block;
    font-size: 17px;
  }
  .list {
    margin-top: 5px;
    padding-left: 44px;
    li {
      margin-bottom: 6px;
      a {
        font-size: 15px;
        color: #666;
        line-height: 20px;
        vertical-align: middle;
        margin-right: 10px;

        &:hover {
          color: #409eff;
        }
      }
    }
  }

  .ant-btn {
    /deep/ .anticon {
      svg {
        position: relative;
        top: 1px;
      }
    }
  }
  .work-btn {
    margin-left: 20px;
  }
  .work-link {
    color: #666;
    &:hover {
      color: #409eff;
    }
  }
}
.name {
  color: #409eff;
  cursor: pointer;
}
</style>
